import { Button, Select, Tooltip } from 'antd';
import { TFunction } from 'i18next';
import { Dispatch, SetStateAction, useMemo, useState } from 'react';
import { useAppSelector } from 'store/hook';
import classes from './ChatTab.module.scss';
import Assets from 'assets/icons';
import Spinner from 'components/Spinner/Spinner';
import { checkIsTariffEnded, checkIsAwaitingPayment } from 'helpers/tariffPayment';

type Props = {
  searchValue: string[];
  isLaoding: boolean;
  onCreateModalOpen: () => void;
  setSearchValue: Dispatch<SetStateAction<string[]>>;
  t: TFunction;
};

function ChatTabControls({
  t,
  searchValue,
  isLaoding,
  onCreateModalOpen,
  setSearchValue,
}: Props) {
  const [tagValue, setTagValue] = useState<string>('');
  const { roomAllChats, globalChats, listStatus } = useAppSelector((state) => state.chat);
  const { dataRoom } = useAppSelector((state) => state.dataRoom);

  const isUnpaidRoom = checkIsAwaitingPayment(dataRoom);
  const isEndedTariff = checkIsTariffEnded(dataRoom);

  const onChange = (value: string[]) => setSearchValue(value);
  const onSearch = (value: string) => setTagValue(value);

  const options = useMemo(() => {
    const items: { value: string }[] = [];
    new Set(
      [...roomAllChats, ...globalChats].map(
        ({ title, entity_type, entity_name }) =>
          entity_type === 2 || entity_type === 3 ? entity_name : title
      )
    ).forEach((title) => items.push({ value: title }));

    return items;
  }, [roomAllChats, globalChats]);

  const modifiedOptions = tagValue
    ? [{ value: tagValue }, ...options]
    : options;  

  return (
    <div className={classes.management}>
      <Select
        mode='multiple'
        allowClear
        style={{ width: '100%', minWidth: 0 }}
        placeholder={t('Chats.searchChat')}
        value={searchValue}
        disabled={isLaoding}
        onSearch={onSearch}
        onChange={onChange}
        options={modifiedOptions}
        suffixIcon={isLaoding
          ? <Spinner size={16}/>
          : <Assets.SearchIcon className={classes.management_searchIcon} />
        }
      />
      <Tooltip title={t('Chats.createButton')}>
        <Button
          disabled={(isUnpaidRoom || isEndedTariff) && listStatus === 'room'}
          type='primary'
          shape='circle'
          icon={<Assets.AddChatIcon />}
          onClick={onCreateModalOpen}
          className={classes.management_plus}
        />
      </Tooltip>
    </div>
  );
}

export default ChatTabControls;
